import React from "react"
import Image from "./image"

const Orangish = ({ filename, alt }) => <Image filename={filename} alt={alt} className="image-filter orange-filter"/>
export default Orangish

